import React from 'react'

import Layout from 'components/Layout'
import Map from 'components/Map'
import '@mapbox/mapbox-gl-directions/dist/mapbox-gl-directions.css'
import directionData from '../constants/directions'

const MapPage = () => {
  return (
    <Layout title="How to reach">
      <Map directions={directionData} styles={['navigation-day-v1']} center={[11.03647, 45.7]} zoom={2}/>
    </Layout>
  )
}

export default MapPage
